import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/images/restricted-area-2.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "Unlock the Full Experience", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "welcome__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "header-sub-title"
}
const _hoisted_4 = {
  key: 1,
  class: "header-sub-title"
}

import CommonDialog from "@/core/components/CommonDialog.vue";
import { USER_STORE } from "@/store/modules/user";
import { computed, ref, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { WORKSTATION } from "@/store/modules/workstation";
import {
  BusinessDetailTypeEnum,
  UserRolesEnum,
  UserVerificationStatusEnum,
} from "@/core/enums/RolesEnum";
import { useRouter } from "vue-router";
import { DASHBOARD_ROUTE } from "@/modules/dashboard/routes";
import AddAddressModal from "@/modules/dashboard/components/Modals/AddAddressModal.vue";
import WorkstationVerificationModal from "@/modules/workstation/components/WorkstationVerificationModal.vue";
import { TRADE_PASSPOSRT_ROUTE } from "@/modules/trade-passport/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageRestrictionNoticeModal',
  emits: ["on-close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter();
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const emit = __emit;
const isOpenAddBusinessAddressModal = ref(false);
const isOpenWorkstationVerificationModal = ref(false);
const textForNotifyUser = ref("");
const textForNotifyUserBtn = ref("");
const userName = computed(
  () => `${user.value?.firstName || "user"} ${user.value?.lastName || "name"}`
);
const onSubmitVerification = ref(false);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const isDefault = computed(() => {
  return activeUserWorkstation.value?.name === "Default";
});
const isShowWelcomeModal = ref(true);

const onCloseModal = () => {
  emit("on-close");
};

const onCreateWorkstation = () => {
  onCloseModal();
  router.push({ name: DASHBOARD_ROUTE });
  if (user.value?.role?.name === UserRolesEnum.TRADESPERSON) {
    store.dispatch(`${WORKSTATION}/setWsModal`, {
      isShowWorkStationModal: true,
    });
  }
};

const isUserAddBusinessAddress = computed(() => {
  if (
    user.value?.userBusinessDetails?.type ===
    BusinessDetailTypeEnum.LIMITED_COMPANY
  ) {
    return user.value.userBusinessDetails.businessPostcode;
  } else {
    return user.value.userBusinessDetails.residencyPostcode;
  }
});
const isUserProfileVerified = computed(
  () => store.getters[`${USER_STORE}/isUserProfileVerifiable`]
);
const isUserKycVerified = computed(
  () =>
    activeUserWorkstation.value?.user?.userKYCVerificationStatus ===
      UserVerificationStatusEnum.VERIFIED ||
    activeUserWorkstation.value?.user?.userKYCVerificationStatus ===
      UserVerificationStatusEnum.PENDING_VERIFICATION
);

const isWorkstationSubmittedForVerification = computed(
  () =>
    activeUserWorkstation.value?.verificationStatus ===
    UserVerificationStatusEnum.PENDING_VERIFICATION
);
const onClickSubmitVerification = async () => {
  try {
    onSubmitVerification.value = true;
    if (activeUserWorkstation.value.subscription === null) {
      store.commit(`${WORKSTATION}/setIsSubmitWsForVerification`, true);
    } else {
      const data = {
        userId: user.value?.id,
        userWorkstationId: activeUserWorkstation.value?.id,
        formData: {
          verificationStatus: UserVerificationStatusEnum.PENDING_VERIFICATION,
        },
      };
      await store.dispatch(`${WORKSTATION}/updateUserWorkstationStatus`, data);
    }

    onCloseModal();
    router.push({ name: DASHBOARD_ROUTE });
  } catch (err) {
    console.log(err);
  } finally {
    onSubmitVerification.value = false;
  }
};
const onClickAction = () => {
  if (!isUserAddBusinessAddress.value) {
    isOpenAddBusinessAddressModal.value = true;
  } else if (!isUserKycVerified.value) {
    isOpenWorkstationVerificationModal.value = true;
  } else if (!isUserProfileVerified.value) {
    router.push({ name: TRADE_PASSPOSRT_ROUTE });
    onCloseModal();
  } else if (isWorkstationSubmittedForVerification.value) {
    onCloseModal();
  } else {
    onClickSubmitVerification();
  }
};
const onClickCloseActionModel = () => {
  isOpenAddBusinessAddressModal.value = false;
  isOpenWorkstationVerificationModal.value = false;
  onCloseModal();
};

onBeforeMount(() => {
  if (!isUserAddBusinessAddress.value) {
    textForNotifyUser.value =
      "Please provide your business address for verification. Once completed, your all-access pass will be assigned.";
    textForNotifyUserBtn.value = "Add Business Address";
  } else if (!isUserKycVerified.value) {
    textForNotifyUser.value =
      "ID Verification Required. Complete your ID verification to have your all-access pass assigned.";
    textForNotifyUserBtn.value = "Complete ID Verification";
  } else if (!isUserProfileVerified.value) {
    textForNotifyUser.value =
      "Please complete your Trade Passport to have your all-access pass assigned";
    textForNotifyUserBtn.value = "Complete Trade Passport";
  } else if (isWorkstationSubmittedForVerification.value) {
    textForNotifyUser.value =
      "Your workstation has already been submitted for verification";
    textForNotifyUserBtn.value = "Close";
  } else {
    textForNotifyUser.value =
      "Submit your workstation for verification to receive your all-access pass.";
    textForNotifyUserBtn.value = "Request for verify workstation";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowWelcomeModal.value)
      ? (_openBlock(), _createBlock(CommonDialog, {
          key: 0,
          isShowHeader: false,
          isShowBackButton: false,
          width: "465px",
          "max-width": "100%",
          height: "auto",
          className: ['restricted__modal_box']
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", {
              class: "dashboard-welcome__close !tw-top-8 !tw-right-8",
              onClick: onCloseModal
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close" })
            ]),
            _hoisted_1,
            _hoisted_2,
            (isDefault.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This was a taste of the premium features. Create your " + _toDisplayString(user.value.role?.name === _unref(UserRolesEnum).TRADESPERSON ? "Trade" : "Property") + " Workstation today and enjoy the full experience. ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(textForNotifyUser.value), 1))
          ]),
          footer: _withCtx(() => [
            (isDefault.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: onCreateWorkstation,
                  class: "button button-purple"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create a " + _toDisplayString(user.value.role?.name === _unref(UserRolesEnum).TRADESPERSON ? "Trade" : "Property") + " Workstation", 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  onClick: onClickAction,
                  class: "button button-orange"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(textForNotifyUserBtn.value || "Verify Workstaion"), 1)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isOpenAddBusinessAddressModal.value)
      ? (_openBlock(), _createBlock(AddAddressModal, {
          key: 1,
          onOnCloseSuccess: onClickCloseActionModel,
          onOnClose: onClickCloseActionModel
        }))
      : _createCommentVNode("", true),
    (isOpenWorkstationVerificationModal.value)
      ? (_openBlock(), _createBlock(WorkstationVerificationModal, {
          key: 2,
          onClickCloseTab: onClickCloseActionModel
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})